import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash.substring(1);
      const params = new URLSearchParams(hash);
      const sessionId = params.get('session_id');

      console.log('Auth callback - session_id:', sessionId ? 'present' : 'missing');

      if (!sessionId) {
        console.error('No session ID in URL hash');
        toast.error('Authentication failed - no session ID');
        navigate('/');
        return;
      }

      try {
        console.log('Requesting auth session from backend...');
        const response = await axios.get(`${API}/auth/session`, {
          headers: { 'X-Session-ID': sessionId },
          withCredentials: true
        });

        console.log('Auth session response received:', response.data);
        console.log('Backend has set session cookie');

        toast.success('Welcome to Bloom & Bond!');
        navigate('/dashboard', { 
          state: { user: response.data.user },
          replace: true 
        });
      } catch (error) {
        console.error('Auth error:', error);
        console.error('Error response:', error.response?.data);
        console.error('Error status:', error.response?.status);
        
        const errorMessage = error.response?.data?.detail || 'Authentication failed. Please try again.';
        toast.error(errorMessage);
        navigate('/');
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-xl font-heading text-foreground">Completing authentication...</p>
      </div>
    </div>
  );
}